import angular from 'angular';
import { sqThresholdMetricStore } from '@/hybrid/tools/thresholdMetric/thresholdMetric.store';

angular.module('Sq.Investigate').store('sqThresholdMetricStore', sqThresholdMetricStore);
